import {
  CREATE_ASSET_REFURBISHED_SUCCESS,
  FETCH_ASSET_REFURBISHED_SUCCESS,
  GET_ASSET_REFURBISHED_SUCCESS,
  SAVE_ASSET_REFURBISHED_QUERY
} from "../../constants/ActionTypes";

const INIT_STATE = {
  total: 0,
  resources: [],
  resource: {},
  edit: {},
  query: {},
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case SAVE_ASSET_REFURBISHED_QUERY: {
      return {
        ...state,
        query: action.query
      }
    }

    case GET_ASSET_REFURBISHED_SUCCESS: {
      const query = {...state.query};
      query.pagination.total = action.count;

      return {
        ...state,
        query: query,
        resources: action.data,
        total: action.total,
      }
    }

    case CREATE_ASSET_REFURBISHED_SUCCESS: {
      return {
        ...state,
        resource: action.data,
      }
    }

    case FETCH_ASSET_REFURBISHED_SUCCESS: {
      return {
        ...state,
        edit: action.data,
      }
    }


    default:
      return state;
  }
}
